module.exports = __webpack_public_path__ + "img/calculate.de969c03.svg";